import React from "react";
import { useLocation } from "react-router-dom";
import { commonString } from "../../../../../AdminApi/commFunc";
import ChildPageNav from "../../../../DefaultStyles/ChildPageNav";
import PageTitle from "../../../../DefaultStyles/PageTitle";
import SpaceBetween from "../../../../DefaultStyles/SpaceBetween";

export default function ManageFaqDetailTitle() {
  const { pathname } = useLocation();

  const isAddFaq = Boolean(pathname?.includes("add"));

  const title = `${commonString(pathname).title} ${isAddFaq ? "추가" : "상세"}`;
  const prevPage = commonString(pathname).route;
  return (
    <SpaceBetween>
      <>
        <PageTitle title={title} route={`/linkid-manage/${prevPage}`} />

        <ChildPageNav
          parentRoute={`/linkid-manage/${prevPage}`}
          childPageTitle={title}
        />
      </>
    </SpaceBetween>
  );
}
